import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { contactAll } from '../redux/actions';

// รวม logic ค้นหา (debounce 300ms) + pagination + sync rows จาก Redux ไว้ที่เดียว
// ใช้ร่วมกันได้ทั้งหน้า Client และ Suppliers (ต่างกันแค่ contactType ที่กรอง)
export default function useContactList(contactType) {
  const dispatch = useDispatch();
  const contact = useSelector((state) => state.contact);

  const [localRows, setLocalRows] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(1);

  useEffect(() => {
    const t = setTimeout(() => { setSearchTerm(inputValue); setPage(1); }, 300);
    return () => clearTimeout(t);
  }, [inputValue]);

  useEffect(() => {
    dispatch(contactAll({ name: searchTerm, size, page, contactType }));
  }, [dispatch, searchTerm, size, page, contactType]);

  // Sync local rows from Redux (only on fresh fetch, not during optimistic updates)
  useEffect(() => {
    if (!contact.isLoading && contact.rows) {
      setLocalRows(contact.rows);
    }
  }, [contact.rows, contact.isLoading]);

  const refetch = () => dispatch(contactAll({ name: searchTerm, size, page, contactType }));

  return {
    contact, localRows, setLocalRows, inputValue, setInputValue, searchTerm, size, setSize, page, setPage, refetch,
  };
}
